import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "../api";
import { useAuth } from "../context/AuthContext";
import { toast } from "../hooks/use-toast";
import AuthLayout from "../components/AuthLayout";

export default function ArtistSignup() {
  const { reload } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", city: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/artist/register", form);
      localStorage.setItem("gp_token", data.token);
      await reload();
      toast({ title: "Profile created", description: "Set up your bio, fee and start connecting." });
      nav("/artist");
    } catch (err) {
      toast({ title: "Sign up failed", description: err?.response?.data?.detail || "Please try again", variant: "destructive" });
    } finally { setLoading(false); }
  };

  const field = (label, key, type = "text", ph = "", required = true) => (
    <div>
      <label className="block text-sm font-medium text-[#16243b] mb-1.5">{label}</label>
      <input type={type} required={required} value={form[key]} onChange={set(key)} placeholder={ph} data-testid={`artist-signup-${key}`}
        className="w-full rounded-xl border border-gray-200 px-4 py-3 outline-none focus:border-[#2ec9c9] focus:ring-2 focus:ring-[#2ec9c9]/20 transition" />
    </div>
  );

  return (
    <AuthLayout title="Create your artist profile" subtitle="One profile. Get discovered and booked by venues & promoters.">
      <form onSubmit={submit} className="space-y-4">
        {field("Artist / act name", "name", "text", "DJ Aurora")}
        {field("Email", "email", "email", "you@example.com")}
        {field("Password", "password", "password", "Create a password")}
        {field("City (optional)", "city", "text", "Glasgow", false)}
        <button disabled={loading} data-testid="artist-signup-submit" className="gp-btn-teal w-full rounded-xl py-3 font-medium disabled:opacity-60">
          {loading ? "Creating…" : "Create artist profile"}
        </button>
      </form>
      <p className="text-sm text-[#5a6b80] mt-6 text-center">
        Already have an account? <Link to="/login" className="text-[#1fb0b0] font-medium hover:underline">Sign in</Link>
      </p>
    </AuthLayout>
  );
}
